var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBookmark48Line = function SvgIconBookmark48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8 38.7a2.88 2.88 0 0 1-1.39-.36L24 33.75l-8.41 4.59a2.9 2.9 0 0 1-4.29-2.54V14.6a5.3 5.3 0 0 1 5.3-5.3h14.8a5.3 5.3 0 0 1 5.3 5.3v21.2a2.87 2.87 0 0 1-1.42 2.49 2.921 2.921 0 0 1-1.48.41ZM24 30.11c.283 0 .562.073.81.21l8.49 4.63V14.6a1.91 1.91 0 0 0-1.9-1.9H16.6a1.9 1.9 0 0 0-1.9 1.9v20.35l8.48-4.63a1.72 1.72 0 0 1 .82-.21Z",
    fill: "current"
  })));
};
export default SvgIconBookmark48Line;